import { getWidgetStyleConfig } from "../../../configs";

export const getColorValueWithActive = (id, value) => {
  const condition = [
    "case",
    ["==", ["get", "id"], String(id)],
    "rgb(255, 68, 140)"
  ];
  return id ? [...condition, value] : value;
};

export const getWidthValueWithActive = (id, value) => {
  const condition = ["case", ["==", ["get", "id"], String(id)], 3];
  return id ? [...condition, value] : value;
};

export const getSymbolValueWithActive = (id, activeIcon, value) => {
  const condition = ["case", ["==", ["get", "id"], String(id)], activeIcon];
  return id ? [...condition, value] : value;
};

export const updateLayerStyle = (state, val, isDefault = false) => {
  const sourceName = isDefault
    ? state.prevActiveCard.sourcename
    : state.activeCardLayerId;
  const features = state.layersData[sourceName];
  const featuresByTypes = {};
  if (!features) return;
  features.forEach(e => {
    if (e.geom) {
      if (!featuresByTypes[e.geom.type]) featuresByTypes[e.geom.type] = [];
      featuresByTypes[e.geom.type].push(e);
    }
  });
  const types = Object.keys(featuresByTypes);
  const findType = types.find(e => featuresByTypes[e].find(n => n.id === val));
  if (!findType) return;

  const sourceId = `${sourceName}_sc_map_${findType}`;
  const source = state.mapgl.getSource(sourceId);
  if (!source) return;
  const layer = state.mapgl.getLayer(sourceId);
  if (!layer) return;
  const { type } = layer;
  const property = type === "circle" ? `${type}-stroke-color` : `${type}-color`;
  const defaultColor =
    state.scLayersConfig[`${sourceName}_${findType}`].paint[property];
  const value = isDefault
    ? defaultColor
    : getColorValueWithActive(val, defaultColor);
  state.mapgl.setPaintProperty(sourceId, property, value);
  if (type === "circle") {
    const defaultStroke =
      state.scLayersConfig[`${sourceName}_Point`].paint["circle-stroke-width"];
    const strokeValue = isDefault
      ? defaultStroke
      : getWidthValueWithActive(val, defaultStroke);
    state.mapgl.setPaintProperty(sourceId, "circle-stroke-width", strokeValue);

    const activeIcon = getActiveIcon(sourceName);
    if (activeIcon) {
      const defaultSymbol =
        state.scLayersConfig[`${sourceName}_Point_s`].layout["icon-image"];
      const symbolValue = isDefault
        ? defaultSymbol
        : getSymbolValueWithActive(val, activeIcon, defaultSymbol);
      state.mapgl.setLayoutProperty(`${sourceId}_s`, "icon-image", symbolValue);
    }
  }
};

const getActiveIcon = layer_id => {
  const layerStyles = getWidgetStyleConfig(layer_id);

  return layerStyles && layerStyles.icons ? layerStyles.icons.active : null;
};
